export const VideoCaptureProperties = Object.freeze({
  CAP_PROP_POS_MSEC: 0,
  CAP_PROP_POS_FRAMES: 1,
  CAP_PROP_POS_AVI_RATIO: 2,
  CAP_PROP_FRAME_WIDTH: 3,
  CAP_PROP_FRAME_HEIGHT: 4,
  CAP_PROP_FPS: 5,
  CAP_PROP_FOURCC: 6,
  CAP_PROP_FRAME_COUNT: 7,
  CAP_PROP_FORMAT: 8,
  CAP_PROP_MODE: 9,
  CAP_PROP_BRIGHTNESS: 10,
  CAP_PROP_CONTRAST: 11,
  CAP_PROP_SATURATION: 12,
  CAP_PROP_HUE: 13,
  CAP_PROP_GAIN: 14,
  CAP_PROP_EXPOSURE: 15,
  CAP_PROP_CONVERT_RGB: 16,
  CAP_PROP_WHITE_BALANCE_BLUE_U: 17,
  CAP_PROP_RECTIFICATION: 18,
  CAP_PROP_MONOCHROME: 19,
  CAP_PROP_SHARPNESS: 20,
  CAP_PROP_AUTO_EXPOSURE: 21,
  CAP_PROP_GAMMA: 22,
  CAP_PROP_TEMPERATURE: 23,
  CAP_PROP_TRIGGER: 24,
  CAP_PROP_TRIGGER_DELAY: 25,
  CAP_PROP_WHITE_BALANCE_RED_V: 26,
  CAP_PROP_ZOOM: 27,
  CAP_PROP_FOCUS: 28,
  CAP_PROP_GUID: 29,
  CAP_PROP_ISO_SPEED: 30,
  CAP_PROP_BACKLIGHT: 32,
  CAP_PROP_PAN: 33,
  CAP_PROP_TILT: 34,
  CAP_PROP_ROLL: 35,
  CAP_PROP_IRIS: 36,
  CAP_PROP_SETTINGS: 37,
  CAP_PROP_BUFFERSIZE: 38,
  CAP_PROP_AUTOFOCUS: 39,
});

export const ImwriteFlags = Object.freeze({
  IMWRITE_JPEG_QUALITY: 1,
  IMWRITE_JPEG_PROGRESSIVE: 2,
  IMWRITE_JPEG_OPTIMIZE: 3,
  IMWRITE_JPEG_RST_INTERVAL: 4,
  IMWRITE_JPEG_LUMA_QUALITY: 5,
  IMWRITE_JPEG_CHROMA_QUALITY: 6,
  IMWRITE_PNG_COMPRESSION: 16,
  IMWRITE_PNG_STRATEGY: 17,
  IMWRITE_PNG_BILEVEL: 18,
  IMWRITE_PXM_BINARY: 32,
  // IMWRITE_EXR_TYPE: (3 << 4) + 0,
  IMWRITE_WEBP_QUALITY: 64,
  IMWRITE_PAM_TUPLETYPE: 128,
  IMWRITE_TIFF_RESUNIT: 256,
  IMWRITE_TIFF_XDPI: 257,
  IMWRITE_TIFF_YDPI: 258,
  IMWRITE_TIFF_COMPRESSION: 259,
});

export const RotateFlags = Object.freeze({
  ROTATE_90_CLOCKWISE: 0, // Rotate 90 degrees clockwise
  ROTATE_180: 1, // Rotate 180 degrees clockwise
  ROTATE_90_COUNTERCLOCKWISE: 2, // Rotate 270 degrees clockwise
  NO_ROTATION: 3, // No rotation - Artifical no rotation flag for opencv!
});
